import Cookies from 'js-cookie'
import axios from 'axios'
import router from '@/router'

const Axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

Axios.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${Cookies.get('ami_user_token') || ''}`
  return config
})

Axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      Cookies.remove('ami_user_token')
      router.push({ name: 'Login' })
    }
    return Promise.reject(error)
  }
)

export default Axios
